"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeTermSelector = void 0;

var activeTermSelector = function activeTermSelector(_ref) {
  var activeTerm = _ref.activeTerm;
  return activeTerm;
};

exports.activeTermSelector = activeTermSelector;